// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.FoldingFrame_container__ZTeZp {
    width: 100%;
    height: auto;
    padding: 27px 16px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    margin-bottom: 16px;
}

.FoldingFrame_container__header__NZlO8 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 28px;
    border-bottom: 1px solid #D9D9D9;
    margin-bottom: 10px;
}

.FoldingFrame_container__header_title__iA4tC {
    color: #0F051D;
    font-size: 20px;
    font-weight: bold;
    line-height: 27px;
    -webkit-user-select: none;
            user-select: none;
}

.FoldingFrame_container__header_icon__Pceib {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 27px;
    height: 27px;
    cursor: pointer;
}

.FoldingFrame_container__header_icon__Pceib:hover {
    background-color: #f9f9f9;
    border-radius: 6px;
}

.FoldingFrame_container__collapse__uwy9u .ant-collapse-header {
    display: none !important;
}

.FoldingFrame_container__collapse__uwy9u.ant-collapse,
.FoldingFrame_container__collapse__uwy9u .ant-collapse-content {
    border: none !important;
    background-color: #fff !important;
}

.FoldingFrame_container__collapse__uwy9u .ant-collapse-content-box {
    padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/detail/components/FoldingFrame/index.module.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["\n.container {\n    width: 100%;\n    height: auto;\n    padding: 27px 16px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    margin-bottom: 16px;\n}\n\n.container__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 28px;\n    border-bottom: 1px solid #D9D9D9;\n    margin-bottom: 10px;\n}\n\n.container__header_title {\n    color: #0F051D;\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 27px;\n    user-select: none;\n}\n\n.container__header_icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 27px;\n    height: 27px;\n    cursor: pointer;\n}\n\n.container__header_icon:hover {\n    background-color: #f9f9f9;\n    border-radius: 6px;\n}\n\n.container__collapse :global(.ant-collapse-header) {\n    display: none !important;\n}\n\n.container__collapse:global(.ant-collapse),\n.container__collapse :global(.ant-collapse-content) {\n    border: none !important;\n    background-color: #fff !important;\n}\n\n.container__collapse :global(.ant-collapse-content-box) {\n    padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FoldingFrame_container__ZTeZp`,
	"container__header": `FoldingFrame_container__header__NZlO8`,
	"container__header_title": `FoldingFrame_container__header_title__iA4tC`,
	"container__header_icon": `FoldingFrame_container__header_icon__Pceib`,
	"container__collapse": `FoldingFrame_container__collapse__uwy9u`
};
export default ___CSS_LOADER_EXPORT___;
